import { Arg, Metadata } from '../../../../utils/spds/metadata';
import FlexColumn from '../../layout/flex/column.gjs';
import Super from '../../core/base.gjs';
import styles from './preview.module.scss';

export const DEFAULT_WIDTH = 'half';
export const PREVIEW_WIDTHS = [DEFAULT_WIDTH, 'one-third', 'two-thirds'];

const METADATA = Metadata.define({
  description: 'Preview pane for full-screen modal.',
  meta: {
    hide: Arg.boolean({ default: false }),
    width: Arg.string({
      default: DEFAULT_WIDTH,
      description: 'Width of the preview pane',
      options: PREVIEW_WIDTHS,
    }),
  },
  name: 'Preview',
});

export default class SpdsModalFullScreenPreview extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-full-screen-preview-pane';
  classesToMap = ['hide', 'width'];
  styles = styles;

  get flex() {
    switch (this.width) {
      case PREVIEW_WIDTHS[1]:
        return '1';
      case PREVIEW_WIDTHS[2]:
        return '4';
      case PREVIEW_WIDTHS[0]:
      default:
        return '2';
    }
  }

  get width() {
    return this.argOrDefault('width');
  }

  <template>
    <FlexColumn
      @flex={{this.flex}}
      class={{this.classes}}
      data-test-spds-modal-full-screen-preview-pane
      {{this.validateArguments}}
      ...attributes
    >
      {{yield}}
    </FlexColumn>
  </template>
}

export const MODAL_FULL_SCREEN_PREVIEW_METADATA = SpdsModalFullScreenPreview.metadata;
